import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterSidebar = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  isOpen, 
  onToggle,
  totalCourses,
  filteredCount 
}) => {
  const categories = [
    'ICT Technician',
    'Cybersecurity',
    'Building Technology',
    'Electrical Engineering',
    'Civil Engineering',
    'Business',
    'Agriculture',
    'Social Work',
    'Hospitality',
    'Fashion Design',
    'Cosmetology',
    'KASNEB Courses',
    'Dual TVET',
    'RPL Programs'
  ];

  const levels = ['Three', 'Four', 'Five', 'Six','KNEC','Advanced'];
  const certifications = ['TVET CDACC', 'KASNEB', 'KNEC','KARUMO TTI'];

  const handleCheckboxChange = (filterType, value, checked) => {
    const currentValues = filters?.[filterType] || [];
    const newValues = checked
      ? [...currentValues, value]
      : currentValues?.filter(v => v !== value);
    
    onFilterChange(filterType, newValues);
  };

  const handleRangeChange = (filterType, field, value) => {
    onFilterChange(filterType, {
      ...filters?.[filterType],
      [field]: value
    });
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden"
          onClick={onToggle}
        />
      )}
      {/* Sidebar */}
      <div className={`
        fixed lg:sticky top-0 left-0 h-screen lg:h-auto w-80 lg:w-full
        bg-card border-r border-border lg:border-r-0 lg:border border-border lg:rounded-xl
        transform transition-transform duration-300 ease-in-out z-50 lg:z-auto
        overflow-y-auto lg:overflow-visible
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-4 lg:p-6">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-foreground">Filters</h2>
              <p className="text-sm text-muted-foreground">
                {filteredCount} of {totalCourses} courses
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <Button
                variant="ghost"
                size="lg"
                onClick={onClearFilters}
                iconName="RotateCcw"
                iconPosition="left"
              >
                Clear
              </Button>
              <button
                onClick={onToggle}
                className="lg:hidden p-2 hover:bg-muted rounded-lg transition-colors"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
          </div>
        </div>

        <div className="p-4 lg:p-6 space-y-6">
          {/* Search */}
          <div>
            <Input
              type="search"
              placeholder="Search courses..."
              value={filters?.search || ''}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Category Filter */}
          <div>
            <h3 className="font-medium text-foreground mb-3 flex items-center">
              <Icon name="Folder" size={16} className="mr-2" />
              Category
            </h3>
            <div className="space-y-2 max-h-48 overflow-y-auto">
              {categories?.map((category) => (
                <Checkbox
                  key={category}
                  label={category}
                  checked={(filters?.categories || [])?.includes(category)}
                  onChange={(e) => handleCheckboxChange('categories', category, e?.target?.checked)}
                />
              ))}
            </div>
          </div>

          {/* Level Filter */}
          <div>
            <h3 className="font-medium text-foreground mb-3 flex items-center">
              <Icon name="BarChart3" size={16} className="mr-2" />
              Level
            </h3>
            <div className="space-y-2">
              {levels?.map((level) => (
                <Checkbox
                  key={level}
                  label={level}
                  checked={(filters?.levels || [])?.includes(level)}
                  onChange={(e) => handleCheckboxChange('levels', level, e?.target?.checked)}
                />
              ))}
            </div>
          </div>

          {/* Certification Filter */}
          <div>
            <h3 className="font-medium text-foreground mb-3 flex items-center">
              <Icon name="Award" size={16} className="mr-2" />
              Certification
            </h3>
            <div className="space-y-2">
              {certifications?.map((cert) => (
                <Checkbox
                  key={cert}
                  label={cert}
                  checked={(filters?.certifications || [])?.includes(cert)}
                  onChange={(e) => handleCheckboxChange('certifications', cert, e?.target?.checked)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;